"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const Box_1 = __importDefault(require("@mui/material/Box"));
const ListItemAvatar_1 = __importDefault(require("@mui/material/ListItemAvatar"));
const react_auth_code_input_1 = __importDefault(require("react-auth-code-input"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const ProgressiveImage_1 = __importDefault(require("../../../common/components/Other/ProgressiveImage"));
const globalVariables_1 = require("../../../common/globalVariables");
const helpers_1 = require("../../../common/helpers/helpers");
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const ConventionsPageWrapper = styled_components_1.default.div `
    width: 100%;
    height: 100%;
    background: #ffffff;

   .convention-enter-code-wrapper {
    max-width: 650px;
    margin: 5vmin auto 0;
    display: flex;
    flex-direction: column;
    height: calc(100% - 95px);
    justify-content: center;
    align-items: center;
    padding: 0 16px;
   }

   .enter-code-title {
        font-size: 25px;
        letter-spacing: .5px;
        font-weight: 400;
        color: #000000de;
        margin-bottom: 25px;

        @media (min-width: 1024px) {
            font-size: 32px;
            margin-bottom: 50px;
        }
   }

    .inputs-container {
        display:flex;
        gap: 10px;

       .code-input {
            aspect-ratio: 1/1;
            width: 100%;
            max-width: 70px;
            padding: 0;
            font-size: 24px;
            text-align: center;
            text-transform: uppercase;
            color: #494949;
            border: 1px solid #d6d6d6;
            border-radius: 4px;
            background: #fff;
            background-clip: padding-box;

            &:focus {
                outline: 0;
                box-shadow: 0 0 0 3px rgb(131 192 253/50%);
            }
       }
   }

   .code-button {
        margin-top: 40px;
        @media (min-width: 1024px) {
            margin-top: 80px;
        }

        &-another-convention {
            display: flex;
            margin: 0 auto;
            color: #33b5e5;
            background-color: #fff;
            box-shadow: none;
            border: 1px solid #E7E7E8;
            margin-top: 55px;

            &:hover {
                color: #fff;
                background-color: #33b5e5;
            }
        }
   }

   .box-wrapper {
        max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px;
        margin: 3.7vmin auto 5.5vmin;
        text-align: center;
        padding: 0 16px 16px;
   }

   .convention-item {
        display: flex;
        align-items: center;
        box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.3);
        border-radius: 10px;
        padding: 5px;
        margin-bottom: 1.58vmin;
        cursor: pointer;

        img {
            width: 120px;
            border-radius: 7px;
        }
   }

   .convention-no-image {
        background-color: #e6e6e6;
        width: 120px;
        min-width: 120px;
        height: 120px;
        border-radius: 7px;
   }
`;
const ConventionData = styled_components_1.default.div `
    margin-left: 10px;

    @media (min-width: 840px) {
        margin-left: 15px;
    }
`;
const ConventionTitle = styled_components_1.default.div `
    font-size: 20px;
    font-weight: 400;
    letter-spacing: .5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
`;
const ConventionDate = styled_components_1.default.div `
    font-size: 14px;
    letter-spacing: .25px;
    color: rgba(0, 0, 0, 0.54);
`;
const YourConventions = styled_components_1.default.div `
    font-size: 22px;
    letter-spacing: .5px;
    margin-bottom: 20px;
    text-align: left;

    @media (min-width: 1024px) {
        font-size: 30px;
        margin-bottom: 40px;
    }
`;
const CheckinError = styled_components_1.default.div `
    color: red;
    font-style: italic;
    margin-top: 20px;
`;
const LoaderWrapper = styled_components_1.default.div `
    position: relative;
    height: 100px;
`;
const Conventions = (props) => {
    const [conventionCode, setConventionCode] = (0, react_1.useState)("");
    const [userConventions, setUserConventions] = (0, react_1.useState)([]);
    const [disableButton, setDisableButton] = (0, react_1.useState)(true);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [checkinError, setCheckinError] = (0, react_1.useState)("");
    const AuthInputRef = (0, react_1.useRef)(null);
    const userToken = props.userData.token;
    setTimeout(() => {
        setIsLoading(false);
    }, 500);
    const fetchUserConventions = () => {
        apiService_1.default.getUserConventions(props.currentLocale, userToken).then((data) => {
            setUserConventions(data);
        });
    };
    (0, react_1.useEffect)(() => {
        fetchUserConventions();
    }, []);
    const clearAuthCode = () => { var _a; return (_a = AuthInputRef.current) === null || _a === void 0 ? void 0 : _a.clear(); };
    const checkinConvention = (code) => {
        if (!code) {
            return;
        }
        setDisableButton(true);
        apiService_1.default.checkInConvention(props.currentLocale, userToken, code).then((data) => {
            if (data.status === "error") {
                setCheckinError(data.message);
            }
            else {
                fetchUserConventions();
                apiService_1.default
                    .getActivities({ locale: props.currentLocale, userToken })
                    .then((activities) => {
                    props.updateStore("unfilteredActivities", activities);
                });
                setConventionCode("");
                setCheckinError("");
                clearAuthCode();
            }
            setDisableButton(false);
        });
    };
    const showConventionDetail = (code, name) => {
        props.history.push({
            pathname: `${props.match.url}/${code}`,
            search: props.location.search,
            state: { name },
        });
    };
    const renderUserConventions = () => userConventions.map((convention) => {
        const startDate = helpers_1.Helpers.getDateFromStringDependingLocale(convention.start, props.currentLocale).date;
        const endDate = helpers_1.Helpers.getDateFromStringDependingLocale(convention.end, props.currentLocale).date;
        return (react_1.default.createElement(Box_1.default, { key: convention.code, onClick: () => {
                showConventionDetail(convention.code, convention.title);
            }, className: "convention-item" },
            convention.thumbnail ? (react_1.default.createElement(ListItemAvatar_1.default, null,
                react_1.default.createElement(ProgressiveImage_1.default, { image: convention.thumbnail, alt: convention.title }))) : (react_1.default.createElement(Box_1.default, { className: "convention-no-image" })),
            react_1.default.createElement(ConventionData, null,
                react_1.default.createElement(ConventionTitle, null, convention.title),
                react_1.default.createElement(ConventionDate, null,
                    " ",
                    `${i18n_js_1.default.t("dictionary.from")} ${startDate} ${i18n_js_1.default.t("dictionary.until")} ${endDate} `,
                    " "))));
    });
    const onChangeInput = (e) => {
        const codeLengthValid = e.length === 6;
        setConventionCode(e);
        setDisableButton(!codeLengthValid);
    };
    return (react_1.default.createElement(ConventionsPageWrapper, null, isLoading
        ? react_1.default.createElement(LoaderWrapper, null,
            react_1.default.createElement(Loader_1.default, null))
        : renderContent()));
    function renderContent() {
        if (userConventions.length > 0) {
            return (react_1.default.createElement(Box_1.default, { className: "box-wrapper" },
                react_1.default.createElement(YourConventions, null, i18n_js_1.default.t("your_conventions")),
                react_1.default.createElement(Box_1.default, null, renderUserConventions()),
                react_1.default.createElement(material_1.Button, { variant: "outlined", fullWidth: true, size: "large", onClick: () => {
                        helpers_1.Helpers.openModal(modalEnums_1.default.CONVENTION, {
                            checkinError,
                            disableButton,
                            AuthInputRef,
                            checkinConvention,
                            onChangeInput,
                        });
                    }, className: "code-button", id: "aqa_log_into_convention" }, i18n_js_1.default.t("convention_another_code"))));
        }
        return (react_1.default.createElement(Box_1.default, { className: "convention-enter-code-wrapper" },
            react_1.default.createElement(material_1.Typography, { className: "enter-code-title" },
                " ",
                i18n_js_1.default.t("convention_code_text"),
                " "),
            react_1.default.createElement(react_auth_code_input_1.default, { ariaLabel: i18n_js_1.default.t("convention_code"), onChange: (e) => onChangeInput(e), inputClassName: "code-input", containerClassName: "inputs-container", allowedCharacters: "numeric", 
                // id="aqa_convention_code" //CHECK
                ref: AuthInputRef }),
            checkinError && (react_1.default.createElement(CheckinError, null, checkinError)),
            react_1.default.createElement(material_1.Button, { variant: "contained", fullWidth: true, size: "large", disabled: disableButton, onClick: () => {
                    checkinConvention(conventionCode);
                }, className: "code-button", id: "aqa_log_into_convention" }, i18n_js_1.default.t("log_in_convention"))));
    }
};
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(Conventions));
